import React from 'react';
import styled from 'styled-components';
import { get, isEmpty } from 'lodash';
import { object, bool, string, func } from 'prop-types';
import ConditionalRender from 'app-components/shared/ConditionalRender';
import { FlexContainer } from 'base-components';
import { Text, InputWithMemory } from 'app-components/common';
import SelectIcon from './SelectIcon';

const OptionItemSelectedWrapper = styled(FlexContainer)`
    border: solid 1px transparent;
    background: #f4f4f4;
    border-radius: 9.5px;
    padding: 0px 3px;
    margin-right: 3px;
    margin-bottom: 3px;
    margin-top: 3px;

    &:hover {
    border-color: #f4f4f4;;
    }
`;

const SelectButtonWrapper = styled(FlexContainer)`
    padding: 1px 5px;
    flex-wrap: wrap;
    max-height: 130px;
    overflow: auto;
`;

const OptionItemTag = ({ value, children, onClick }) => {
    return (
        <OptionItemSelectedWrapper>
            <Text renderAs='span' text={children} style={{ padding: '0px 4px' }} />
            <SelectIcon justify='center' onClick={(e) => { e.stopPropagation(); onClick({ value }); }}>
                <span className='icon-ic-cross' style={{ fontSize: '.5rem' }} />
            </SelectIcon>
        </OptionItemSelectedWrapper>
    );
};

OptionItemTag.propTypes = {
    value: string,
    onClick: func,
    children: object
};

const SelectButton = ({ label, placeholderAllSelected, context: SelectContext }) => {
    return (
        <SelectContext.Consumer>
            {({ selected, isMultiple, onRemove, onFilterChange, allSelected, toggleSelectAll, autoComplete, filterBy, setOpenedSelect, opened, fromUserSelect, options }) => {
                const renderInitially = (!opened && isEmpty(selected)) || !isMultiple;
                return <SelectButtonWrapper flex='1' diretion='row' align='center' onClick={setOpenedSelect}>
                    {/* Render if "multiple" mode is enabled */}
                    <ConditionalRender condition={(!isEmpty(selected) && isMultiple && !allSelected && !opened)}>
                        {selected.map(({ value, label }, key) => (<OptionItemTag key={`${key}-${label}`} onClick={onRemove} value={value}>{label}</OptionItemTag>))}
                    </ConditionalRender>

                    {/* Render if "autocomplete" option is enabled */}
                    <ConditionalRender condition={opened || renderInitially}>
                        <InputWithMemory
                            placeholder={label}
                            onChange={onFilterChange}
                            initialValue={get(isMultiple ? [] : selected, '0.label', '')}
                        />
                    </ConditionalRender>

                    {/* Render if "all selected" option is active */}
                    <ConditionalRender condition={allSelected && !opened}>
                        <OptionItemTag onClick={toggleSelectAll}>{placeholderAllSelected || 'Todos'}</OptionItemTag>
                    </ConditionalRender>
                </SelectButtonWrapper>;
            }}
        </SelectContext.Consumer>
    );
};

SelectButton.propTypes = {
    label: string,
    placeholderAllSelected: bool,
    context: object
};

export default SelectButton;
